import React, { useState, useEffect, useRef } from "react";
import withRouter from "components/Common/withRouter";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner,
  Badge,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import axios from "axios";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

const API_BASE = "https://mansethaberapi.stechomeyazilim.com";
const API_USERS = `${API_BASE}/Users?$format=json&$top=1000`;
const API_SEND_NOTIFICATION = `${API_BASE}/BILDIRIM_LOGLARI`;
const API_TITLE_TEMPLATES = `${API_BASE}/BILDIRIM_BASLIKLARI?$format=json&$top=100&$orderby=SIRA asc`;

// Haber arama + görselleri PHP API'den gelir
const NEWS_API = "https://deneme.stechomeyazilim.info/api/v1";
// Yüklenen görsellerin servis edildiği taban
const UPLOAD_ENDPOINT = "https://mansethaberadmin.stechomeyazilim.info:9092/uploadfile";
const UPLOAD_PUBLIC_BASE = "https://mansethabereklam.stechomeyazilim.info/";

const SOUND_OPTIONS = [
  { value: "default", label: "Varsayılan" },
  { value: "breaking", label: "Son Dakika" },
  { value: "soft", label: "Yumuşak" },
  { value: "chime", label: "Çan" },
];

// Standart başlıklar artık admin panelinden (BILDIRIM_BASLIKLARI) yönetilir.
// Liste boş gelirse aşağıdaki yedek kullanılır.
const FALLBACK_TITLE_OPTIONS = [
  { BASLIK: "Son Dakika", TIP: "son-dakika", SES: "breaking" },
  { BASLIK: "Sıcak Haber", TIP: "sicak-haber", SES: "breaking" },
  { BASLIK: "Flaş Haber", TIP: "flas-haber", SES: "default" },
  { BASLIK: "Önemli", TIP: "onemli", SES: "default" },
  { BASLIK: "Manşet", TIP: "manset", SES: "default" },
  { BASLIK: "Gelişme", TIP: "gelisme", SES: "soft" },
];

const PLATFORM_OPTIONS = [
  { value: "", label: "Tüm Cihazlar" },
  { value: "android", label: "Sadece Android" },
  { value: "ios", label: "Sadece iOS" },
];

const SendNotification = () => {
  document.title = "Bildirim Gönder | Manşet Haber ADMIN PANELI";

  const [titleTemplates, setTitleTemplates] = useState(FALLBACK_TITLE_OPTIONS);
  const [title, setTitle] = useState("");
  const [customTitle, setCustomTitle] = useState("");
  const [body, setBody] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [sound, setSound] = useState("default");
  const [platform, setPlatform] = useState("");
  const [scheduleAt, setScheduleAt] = useState(""); // datetime-local; boşsa anında gider
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [loadingAll, setLoadingAll] = useState(false);
  const [loadingUser, setLoadingUser] = useState(false);
  const [uploading, setUploading] = useState(false);

  // Habere bağlı bildirim
  const [newsQuery, setNewsQuery] = useState("");
  const [newsResults, setNewsResults] = useState([]);
  const [selectedNews, setSelectedNews] = useState(null); // { id, title }
  const [searchingNews, setSearchingNews] = useState(false);
  const searchTimer = useRef(null);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await fetch(API_USERS);
        const json = await res.json();
        if (json && json.value && Array.isArray(json.value)) {
          setUsers(json.value);
        }
      } catch (error) {
        console.error("Kullanıcılar alınamadı:", error);
      }
    };
    fetchUsers();
  }, []);

  // Standart başlık şablonlarını çek (admin panelinden yönetilir)
  useEffect(() => {
    const fetchTitleTemplates = async () => {
      try {
        const res = await fetch(API_TITLE_TEMPLATES);
        const json = await res.json();
        const list = json && Array.isArray(json.value) ? json.value : [];
        const active = list.filter((t) => t.AKTIF !== false);
        if (active.length > 0) setTitleTemplates(active);
      } catch (error) {
        console.error("Başlık şablonları alınamadı:", error);
      }
    };
    fetchTitleTemplates();
  }, []);

  // Başlık seçilince ilgili şablonun sesini otomatik uygula
  const handleTitleChange = (value) => {
    setTitle(value);
    if (value && value !== "custom") {
      const tpl = titleTemplates.find((t) => t.BASLIK === value);
      if (tpl && tpl.SES) setSound(tpl.SES);
    }
  };

  // Haber arama (debounce)
  useEffect(() => {
    if (selectedNews) return; // seçim yapıldıysa arama yapma
    const q = newsQuery.trim();
    if (q.length < 2) {
      setNewsResults([]);
      return;
    }
    if (searchTimer.current) clearTimeout(searchTimer.current);
    searchTimer.current = setTimeout(async () => {
      setSearchingNews(true);
      try {
        const res = await fetch(
          `${NEWS_API}/news?search=${encodeURIComponent(q)}&per_page=8`
        );
        const json = await res.json();
        setNewsResults(json?.success && Array.isArray(json.data) ? json.data : []);
      } catch (e) {
        setNewsResults([]);
      } finally {
        setSearchingNews(false);
      }
    }, 400);
    return () => searchTimer.current && clearTimeout(searchTimer.current);
  }, [newsQuery, selectedNews]);

  const showToast = (success, message) => {
    toastr.options = {
      positionClass: "toast-top-right",
      timeOut: 6000,
      closeButton: true,
      progressBar: true,
    };
    if (success) toastr.success(message, "Başarılı");
    else toastr.error(message, "Hata");
  };

  const resolvedTitle = title === "custom" ? customTitle.trim() : title.trim();

  const pickNews = (n) => {
    setSelectedNews({ id: n.id, title: n.title });
    setNewsResults([]);
    setNewsQuery("");
    // Habere ait kapak görseli varsa önizleme için doldur (backend de otomatik çeker)
    if (n.featured_image && !imageUrl) setImageUrl(n.featured_image);
  };

  const clearNews = () => {
    setSelectedNews(null);
    setNewsQuery("");
    setNewsResults([]);
  };

  const handleUpload = async (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("dataFile", file);
      const res = await axios.post(UPLOAD_ENDPOINT, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      const filename = res?.data?.file?.filename;
      if (filename) {
        setImageUrl(UPLOAD_PUBLIC_BASE + filename);
        showToast(true, "Görsel yüklendi.");
      } else {
        showToast(false, "Görsel yüklenemedi (geçersiz yanıt).");
      }
    } catch (err) {
      console.error("Görsel yükleme hatası:", err);
      showToast(false, "Görsel yüklenirken hata oluştu.");
    } finally {
      setUploading(false);
      e.target.value = ""; // aynı dosyayı tekrar seçebilmek için
    }
  };

  const resolveTip = () => {
    if (title === "custom") return "manuel";
    const tpl = titleTemplates.find((t) => t.BASLIK === title);
    if (tpl && tpl.TIP) return tpl.TIP;
    return title.toLowerCase().replace(/\s+/g, "-");
  };

  const buildPayload = (kullaniciId) => ({
    KULLANICI_ID: kullaniciId,
    BASLIK: resolvedTitle,
    ICERIK: body.trim(),
    thumbnail_url: imageUrl.trim() || "",
    GONDERIM_TARIHI: new Date().toISOString(),
    OKUNDU: false,
    TIP: resolveTip(),
    ILGILI_ID: selectedNews ? Number(selectedNews.id) : 0,
    SES: sound,
  });

  // sendAt: datetime-local (yerel saat) → UTC ISO. Geçmişse gönderilmez (anlık).
  const scheduleParam = () => {
    if (!scheduleAt) return null;
    const d = new Date(scheduleAt);
    if (isNaN(d.getTime()) || d.getTime() <= Date.now()) return null;
    return d.toISOString();
  };

  const buildUrl = (includePlatform) => {
    const params = [];
    if (includePlatform && platform) params.push(`platform=${encodeURIComponent(platform)}`);
    const sa = scheduleParam();
    if (sa) params.push(`sendAt=${encodeURIComponent(sa)}`);
    return params.length ? `${API_SEND_NOTIFICATION}?${params.join("&")}` : API_SEND_NOTIFICATION;
  };

  const sendUrl = () => buildUrl(true);

  const resetForm = () => {
    setTitle("");
    setCustomTitle("");
    setBody("");
    setImageUrl("");
    setSelectedUser("");
    setSound("default");
    setPlatform("");
    setScheduleAt("");
    clearNews();
  };

  const reportSuccess = (res, fallbackMsg) => {
    // Zamanlandıysa
    if (res?.headers?.["x-scheduled"] === "true") {
      const at = res?.headers?.["x-scheduled-at"];
      const when = at ? new Date(at).toLocaleString("tr-TR") : "";
      showToast(true, `Bildirim zamanlandı${when ? `: ${when}` : ""}.`);
      return;
    }
    const count = res?.headers?.["x-target-count"];
    if (count !== undefined && count !== null && count !== "") {
      showToast(true, `Bildirim ${count} cihaza gönderildi.`);
    } else {
      showToast(true, fallbackMsg);
    }
  };

  const sendToAll = async () => {
    if (!resolvedTitle || !body.trim()) {
      showToast(false, "Başlık ve içerik alanları zorunludur.");
      return;
    }
    setLoadingAll(true);
    try {
      const res = await axios.post(sendUrl(), buildPayload(0));
      reportSuccess(res, "Bildirim tüm kullanıcılara gönderildi.");
      resetForm();
    } catch (error) {
      console.error("Bildirim gönderme hatası:", error);
      showToast(false, "Bildirim gönderilirken bir hata oluştu.");
    } finally {
      setLoadingAll(false);
    }
  };

  const sendToUser = async () => {
    if (!resolvedTitle || !body.trim()) {
      showToast(false, "Başlık ve içerik alanları zorunludur.");
      return;
    }
    if (!selectedUser) {
      showToast(false, "Lütfen bir kullanıcı seçin.");
      return;
    }
    setLoadingUser(true);
    try {
      const res = await axios.post(buildUrl(false), buildPayload(Number(selectedUser)));
      reportSuccess(res, "Bildirim seçili kullanıcıya başarıyla gönderildi.");
      resetForm();
    } catch (error) {
      console.error("Kullanıcı bildirim hatası:", error);
      showToast(false, "Bildirim gönderilirken bir hata oluştu.");
    } finally {
      setLoadingUser(false);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Kullanıcılara Bildirim Gönder" />
          <Row>
            <Col lg="8" className="mx-auto">
              <Card>
                <CardBody>
                  <h5 className="card-title mb-4">Yeni Bildirim Oluştur</h5>
                  <Form>
                    <FormGroup className="mb-3">
                      <Label for="notifTitle">Bildirim Başlığı</Label>
                      <Input
                        type="select"
                        id="notifTitle"
                        value={title}
                        onChange={(e) => handleTitleChange(e.target.value)}
                      >
                        <option value="">Başlık seçin...</option>
                        {titleTemplates.map((opt) => (
                          <option key={opt.ID || opt.BASLIK} value={opt.BASLIK}>
                            {opt.BASLIK}
                          </option>
                        ))}
                        <option value="custom">Diğer (Manuel yaz)</option>
                      </Input>
                    </FormGroup>

                    {title === "custom" && (
                      <FormGroup className="mb-3">
                        <Label for="notifCustomTitle">Manuel Başlık</Label>
                        <Input
                          type="text"
                          id="notifCustomTitle"
                          value={customTitle}
                          onChange={(e) => setCustomTitle(e.target.value)}
                          placeholder="Kendi başlığınızı yazın..."
                        />
                      </FormGroup>
                    )}

                    <FormGroup className="mb-3">
                      <Label for="notifBody">Bildirim İçeriği</Label>
                      <Input
                        type="textarea"
                        id="notifBody"
                        rows={4}
                        value={body}
                        onChange={(e) => setBody(e.target.value)}
                        placeholder="Bildirim metnini buraya yazın..."
                      />
                    </FormGroup>

                    {/* Habere bağlı bildirim */}
                    <FormGroup className="mb-3">
                      <Label>İlgili Haber (Opsiyonel)</Label>
                      {selectedNews ? (
                        <div className="d-flex align-items-center gap-2 p-2 border rounded bg-light">
                          <Badge color="success">Haber #{selectedNews.id}</Badge>
                          <span className="flex-grow-1 text-truncate">{selectedNews.title}</span>
                          <Button color="link" className="text-danger p-0" onClick={clearNews}>
                            Kaldır
                          </Button>
                        </div>
                      ) : (
                        <>
                          <Input
                            type="text"
                            value={newsQuery}
                            onChange={(e) => setNewsQuery(e.target.value)}
                            placeholder="Haber başlığında ara (bildirime tıklayınca bu haber açılır)..."
                          />
                          {searchingNews && (
                            <small className="text-muted">Aranıyor...</small>
                          )}
                          {newsResults.length > 0 && (
                            <ListGroup className="mt-1" style={{ maxHeight: 220, overflowY: "auto" }}>
                              {newsResults.map((n) => (
                                <ListGroupItem
                                  key={n.id}
                                  tag="button"
                                  type="button"
                                  action
                                  onClick={() => pickNews(n)}
                                  className="text-start"
                                >
                                  <small className="text-muted">#{n.id}</small> {n.title}
                                </ListGroupItem>
                              ))}
                            </ListGroup>
                          )}
                          <small className="text-muted">
                            Haber seçilirse bildirim o habere yönlendirir ve kapak görseli otomatik eklenir.
                          </small>
                        </>
                      )}
                    </FormGroup>

                    <FormGroup className="mb-3">
                      <Label for="notifImage">Görsel (Opsiyonel)</Label>
                      <Input
                        type="text"
                        id="notifImage"
                        value={imageUrl}
                        onChange={(e) => setImageUrl(e.target.value)}
                        placeholder="https://ornek.com/resim.jpg veya aşağıdan yükleyin"
                      />
                      <div className="mt-2 d-flex align-items-center gap-2">
                        <Label className="btn btn-outline-secondary btn-sm mb-0">
                          {uploading ? (
                            <>
                              <Spinner size="sm" className="me-1" /> Yükleniyor...
                            </>
                          ) : (
                            <>
                              <i className="mdi mdi-upload me-1" /> Görsel Yükle
                            </>
                          )}
                          <input
                            type="file"
                            accept="image/*"
                            hidden
                            disabled={uploading}
                            onChange={handleUpload}
                          />
                        </Label>
                        {imageUrl && (
                          <Button color="link" className="text-danger p-0" onClick={() => setImageUrl("")}>
                            Görseli temizle
                          </Button>
                        )}
                      </div>
                    </FormGroup>

                    <FormGroup className="mb-3">
                      <Label for="notifSound">Bildirim Sesi</Label>
                      <Input
                        type="select"
                        id="notifSound"
                        value={sound}
                        onChange={(e) => setSound(e.target.value)}
                      >
                        {SOUND_OPTIONS.map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>

                    <FormGroup className="mb-3">
                      <Label for="notifPlatform">Hedef Platform</Label>
                      <Input
                        type="select"
                        id="notifPlatform"
                        value={platform}
                        onChange={(e) => setPlatform(e.target.value)}
                      >
                        {PLATFORM_OPTIONS.map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                      </Input>
                      <small className="text-muted">
                        Platform seçimi yalnızca "Tüm Kullanıcılara Gönder" için geçerlidir.
                      </small>
                    </FormGroup>

                    <FormGroup className="mb-3">
                      <Label for="notifSchedule">Zamanla (Opsiyonel)</Label>
                      <div className="d-flex align-items-center gap-2">
                        <Input
                          type="datetime-local"
                          id="notifSchedule"
                          value={scheduleAt}
                          onChange={(e) => setScheduleAt(e.target.value)}
                          style={{ maxWidth: 260 }}
                        />
                        {scheduleAt && (
                          <Button color="link" className="text-danger p-0" onClick={() => setScheduleAt("")}>
                            Temizle
                          </Button>
                        )}
                      </div>
                      <small className="text-muted">
                        Boş bırakılırsa bildirim anında gönderilir. İleri bir tarih/saat
                        seçilirse o zamana planlanır (sunucu Hangfire ile gönderir).
                      </small>
                    </FormGroup>

                    <FormGroup className="mb-4">
                      <Label for="notifUser">Kullanıcı (Opsiyonel)</Label>
                      <Input
                        type="select"
                        id="notifUser"
                        value={selectedUser}
                        onChange={(e) => setSelectedUser(e.target.value)}
                      >
                        <option value="">Tüm Kullanıcılar</option>
                        {users.map((user) => (
                          <option key={user.ID} value={user.ID}>
                            {user.Users_NameSurname} ({user.Users_MailAddress})
                          </option>
                        ))}
                      </Input>
                    </FormGroup>

                    <div className="d-flex gap-3">
                      <Button
                        color="success"
                        onClick={sendToAll}
                        disabled={loadingAll || loadingUser || uploading}
                      >
                        {loadingAll ? (
                          <>
                            <Spinner size="sm" className="me-2" />
                            Gönderiliyor...
                          </>
                        ) : (
                          <>
                            <i className="mdi mdi-bell-check font-size-16 me-2" />
                            Tüm Kullanıcılara Gönder
                          </>
                        )}
                      </Button>

                      <Button
                        color="primary"
                        onClick={sendToUser}
                        disabled={loadingAll || loadingUser || uploading || !selectedUser}
                      >
                        {loadingUser ? (
                          <>
                            <Spinner size="sm" className="me-2" />
                            Gönderiliyor...
                          </>
                        ) : (
                          <>
                            <i className="mdi mdi-bell-ring font-size-16 me-2" />
                            Seçili Kullanıcıya Gönder
                          </>
                        )}
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>

              {(imageUrl || resolvedTitle || body) && (
                <Card>
                  <CardBody>
                    <h6 className="card-title mb-3">Önizleme</h6>
                    <div className="d-flex align-items-start gap-3 p-3 border rounded">
                      {imageUrl && (
                        <img
                          src={imageUrl}
                          alt="preview"
                          style={{ width: 80, height: 80, objectFit: "cover", borderRadius: 8 }}
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                        />
                      )}
                      <div>
                        <h6 className="mb-1">{resolvedTitle || "Bildirim Başlığı"}</h6>
                        <p className="text-muted mb-0">
                          {body || "Bildirim içeriği burada görünecektir."}
                        </p>
                        {selectedNews && (
                          <small className="text-success">
                            → Haber #{selectedNews.id} açılacak
                          </small>
                        )}
                      </div>
                    </div>
                  </CardBody>
                </Card>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(SendNotification);
